module.exports = __webpack_public_path__ + "media/1alB-y-yag.6c6b381c.mp3";